<div class="admin-root">

  <!-- ═══════════ LOCAL LOGIN GATE ═══════════ -->
  <div class="login-screen" *ngIf="!isLoggedIn">
    <div class="login-bg-orbs">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
    </div>
    <div class="login-card">
      <div class="login-logo">
        <div class="logo-icon">🛡️</div>
        <h1>Dream777 Admin</h1>
        <p>Secure Control Center</p>
      </div>
      <form (ngSubmit)="login()" class="login-form">
        <div class="form-group">
          <label>Username</label>
          <div class="input-wrap">
            <span class="input-icon">👤</span>
            <input type="text" [(ngModel)]="loginUsername" name="username"
                   placeholder="Enter username" autocomplete="off" />
          </div>
        </div>
        <div class="form-group">
          <label>Password</label>
          <div class="input-wrap">
            <span class="input-icon">🔒</span>
            <input [type]="showPassword ? 'text' : 'password'"
                   [(ngModel)]="loginPassword" name="password"
                   placeholder="Enter password" />
            <button type="button" class="toggle-pass" (click)="showPassword = !showPassword">
              {{ showPassword ? '🙈' : '👁️' }}
            </button>
          </div>
        </div>
        <div class="login-error" *ngIf="loginError">⚠️ {{ loginError }}</div>
        <button type="submit" class="btn-login">Sign In →</button>
        <p class="hint">Default: admin / admin</p>
      </form>
    </div>
  </div>

  <!-- ═══════════ DREAM777 ADMIN PANEL (iframe) ═══════════ -->
  <div class="iframe-wrapper" *ngIf="isLoggedIn">
    <!-- Topbar with back/logout -->
    <div class="iframe-topbar">
      <div class="iframe-brand">
        <span class="brand-icon">🛡️</span>
        <span class="brand-text">Dream777 Admin Panel</span>
        <span class="live-badge">🟢 Live</span>
      </div>
      <div class="iframe-actions">
        <a href="http://localhost:3002" target="_blank" class="btn-open">
          ↗ Open in new tab
        </a>
        <button class="btn-reload" (click)="reloadFrame()" title="Reload panel">
          🔄 Reload
        </button>
        <button class="btn-logout-top" (click)="logout()">🚪 Logout</button>
      </div>
    </div>

    <!-- Status banner when server is offline -->
    <div class="offline-banner" *ngIf="adminOffline">
      <span>⚠️</span>
      <span>
        Admin server is not running on port 3002.
        Start it with: <code>node admin-server.js</code> inside <strong>Dream777_admin/</strong>
      </span>
      <button class="btn-retry" (click)="checkServer()">Retry</button>
    </div>

    <!-- iframe -->
    <iframe
      #adminFrame
      id="dream777-admin-frame"
      [src]="adminUrl"
      class="admin-iframe"
      [class.iframe-offline]="adminOffline"
      (load)="onFrameLoad()"
      (error)="onFrameError()"
      allow="fullscreen"
      title="Dream777 Admin Panel">
    </iframe>
  </div>

  <!-- TOAST -->
  <div class="toast" *ngIf="toast"
       [class.toast-success]="toast.type === 'success'"
       [class.toast-error]="toast.type === 'error'">
    {{ toast.message }}
  </div>

</div>
